/* eslint-disable import/prefer-default-export */
export const FEATURE_MY_ACCOUNT = 'myAccount'
export const FEATURE_EMAIL_CONSENT = 'emailConsent'
